import React from "react";
import { EditFormComponent } from "src/components/edit-form";
import { SZR_EDIT_LIST_ITEMS } from "src/config/edit-form";
import { ISzrEditFormProps } from "./szr-edit-form-types";

export const SzrEditForm = (props: ISzrEditFormProps) => {
  const {
    editObjData,
    addToModifiedParams,
    setModifiedParamsValidity,
    modifiedParams,
    uniqType,
    uniqUnit,
    empty,
  } = props;

  const listItemsFunc = {
    type: uniqType,
    unit: uniqUnit,
  };
  // if (!editObjData) return null;

  return (
    <EditFormComponent
      editName="СЗР"
      listItemsProp={SZR_EDIT_LIST_ITEMS}
      listItemsFunc={listItemsFunc}
      editObjData={editObjData}
      addToModifiedParams={addToModifiedParams}
      empty={empty}
      setModifiedParamsValidity={setModifiedParamsValidity}
      modifiedParams={modifiedParams}
    />
  );
};
